module.exports = __webpack_public_path__ + "img/ico_haeder08.3dbd395.svg";